import {
  useReadSuperUserUiPreferencesQuery,
  useUpdateSuperUserUiPreferencesMutation,
} from '@/backoffice/redux/api/backoffice/backoffice-api';
import { TUserUiPreferencesApi } from '@/shared/features/user-ui-preferences/context/user-ui-preferences-api-context.types';

// Typed, not cast: the super-user operations alias their fields to the ident names, so they satisfy the same contract.
export const backofficeUserUiPreferencesApi: TUserUiPreferencesApi = {
  useReadUserUiPreferencesQuery: useReadSuperUserUiPreferencesQuery,
  useUpdateUserUiPreferencesMutation: useUpdateSuperUserUiPreferencesMutation,
};
